import "./src/styles/global.css"
import "@fontsource-variable/red-hat-display"
import "@fontsource-variable/red-hat-text"
import posthog from "posthog-js"

export const onClientEntry = () => {
  const token = process.env.GATSBY_POSTHOG_TOKEN
  const host = process.env.GATSBY_POSTHOG_HOST

  if (!token) {
    if (process.env.NODE_ENV !== "production") {
      console.error(
        "GATSBY_POSTHOG_TOKEN variable required by PostHog is missing or un-configured, " +
          "this causes events to be silently missed. " +
          "This error stops appearing once GATSBY_POSTHOG_TOKEN is configured",
      )
    }
    return
  }

  posthog.init(token, {
    api_host: host || "https://us.i.posthog.com",
    capture_pageview: false,
  })
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof posthog !== "undefined" && posthog.__loaded) {
    posthog.capture("$pageview", { $current_url: location.href })
  }
}
